import { useEffect, useState } from "react"
import { private_server } from "../../../../../config"
import { isFormValid, onGetCatalogs, onGetCurrencyValue, onGetErrorMessage, onGetFormData, onSetErrorsToForm, updateAuthorizationHeader } from "../../../../../shared/utility"
import { generic_errors } from "../../../../../texts/esp/genericErrors"
import useProduct from "../../../../../hooks/api/useProduct"

const useAddPurchaseItemModal = ({open, language, onClose, onCompleted, id}) => {

    const productManager = useProduct()

    const [loading, setLoading] = useState(false)
    const [sending, setSending] = useState(false)
    const [loading_prod, setLoadingProd] = useState(false)
    const [error, setError] = useState(null)
    const [form, setForm] = useState(JSON.parse(JSON.stringify(form_data)))

    const [product_selected, setProductSelected] = useState(null);
    const [options, setOptions] = useState([])
   
    const [search, setSearch] = useState("")

    useEffect(() => {
        if(!open){
            setError(null)
            setForm(JSON.parse(JSON.stringify(form_data)))
        }
    }, [open])

    /* let prod_form = {...form.product_id}
    prod_form.options = [...options] */
    
    const actions = {
        onInitModule: async() => {
            
            
        },
        onChangeForm: (data) => {
            console.log(data)
            let temp = { ...form }
            const id = data.config.id
            temp[id] = { ...data }
            /* if(id === 'product_id'){
                //console.log(temp[id].value)
                const _price = options.filter(item => item.value === temp[id].value)
                //console.log(_price[0].cost)
                setPrice(_price[0].cost)
            } */
            if(error) setError(null)
            setForm(temp)
        },
        onInputChange: (e) =>{
            //if(!e || e.target.value === "" || e.target.value === 0) return
            setSearch(e)
        },
        onSearchProduct: async(e, label) => {
            //console.log(e.target.value)
            //console.log(label)
            //if(!e || e.target.value === "" || e.target.value === 0) return
            if(error) setError(null)
            try {

                const params = {limit:30, }
                const filter = {filter:
                    {"OR":[
                        {"field":"name","operator":"LIKE","value":`%${search}%`},
                        {"field":"code","operator":"LIKE","value":`%${search}%`},
                        {"field":"brand","operator":"LIKE","value":`%${search}%`},
                        {"field":"description","operator":"LIKE","value":`%${search}%`},
                    ]}           
                }
                const req = await private_server.get(`/product/all`, {params:{...params, ...filter}})
                /* const cat = req.data.data.products.map(item => {
                    return {value: item.id_product, label: item.code + ' - ' + item.brand + ' - ' + item.name, brand:item.brand, code:item.code, name:item.name}}) */
                const cat = req.data.data.products.map(item => {
                        return {value: item.id_product, label:item.code + ' - ' + item.brand + ' - ' + item.name, code:item.code, brand:item.brand, name:item.name, cost:item.cost}}) 
                setOptions(cat)

                
            } catch (error) {
                console.log(error)
            }
        },
        onChangeProduct: async (item) =>{
            if(item){
                //console.log(item.value)
                setProductSelected(item)
            }
        },
        onSubmit: async() => {
            const errors = isFormValid(form)

            // Error handler
            if(errors && errors.length){
                const _form = onSetErrorsToForm(form, errors)
                setForm(_form)
                setError(generic_errors[language].INCOMPLETE_FORM)
                return
            }

            // Clean data
            const data2send = onGetFormData(form)
            data2send.purchase_order_id = id
            data2send.price_with_tax = (product_selected.cost * 1.16).toFixed(2)
            data2send.product_id = product_selected.value
            console.log(data2send)

            //const product = products.filter(el => el.code === data2send.product_2_id.split(' ')[0])
            //console.log(product[0])

            try {
                setSending(true)
                updateAuthorizationHeader(private_server)
                await private_server.post(`/purchaseorderitem`, data2send)
                onCompleted()
                onClose()
                setError(null)
                setSending(false)

            } catch (error) {
                setSending(false)
                const _error = onGetErrorMessage(error, language)
                if(_error.details){
                    console.log('Actualizar datos')
                    const _error_keys = Object.keys(_error.details).map(item => item)
                    const _form = onSetErrorsToForm(form, _error_keys)
                    console.log(_form)
                    setForm(_form)
                }
                setError(_error ? _error.message : null)
            }
            
        }
    }

    return {loading, sending, error, form, actions, options, product_selected, loading_prod, search} 
}


export default useAddPurchaseItemModal

const form_data = {
    /* product_id: {
        value:null,
        error: false,
        isVisited: false,
        isRequired: true,
        isValid: true,
        options:[],
        config: {
            id: 'product_id',
            type: 'select',
            fullWidth: true,
        },
        rules: {type: 'select'}
    }, */
    quantity: {
        value:null,
        error: false,
        isVisited: false,
        isRequired: true,
        isValid: true,
        config: {
            id: 'quantity',
            type: 'number',
            fullWidth: true,
        },
        rules: {type: 'none'}
    },
}